export type AchievementTier = {
  tier_order: number;
  name: string;
  target_value: number;
  icon_url: string | null;
  is_unlocked: boolean;
  unlocked_at: string | null;
};

export type AchievementTierSummary = {
  tier_order: number;
  name: string;
  icon_url: string | null;
  unlocked_at?: string | null;
  target_value?: number;
};

export type AchievementFamilyProgress = {
  family_id: string;
  family_key: string;
  family_name: string;
  criteria_type: string;
  current_value: number;
  current_tier: AchievementTierSummary | null;
  next_tier: AchievementTierSummary | null;
  progress_percent: number;
  tiers: AchievementTier[];
};

export type MyAchievementsResponse = {
  families: AchievementFamilyProgress[];
  summary: {
    total_unlocked_tiers: number;
    total_visible_tiers: number;
  };
};

export type PublicAchievement = {
  id: string;
  code: string;
  family_key: string;
  family_name: string;
  tier_order: number;
  name: string;
  category: string;
  icon_url: string | null;
  unlocked_at: string | null;
};

export type PublicAchievementsResponse = {
  profile_hidden: boolean;
  user?: { id: string; display_name: string | null };
  unlocked_count?: number;
  achievements: PublicAchievement[];
};

async function achievementFetch<T>(url: string): Promise<T> {
  const response = await fetch(url, {
    credentials: 'same-origin',
    headers: { Accept: 'application/json' },
  });
  if (!response.ok) throw new Error(`Achievements API failed: ${response.status}`);
  return response.json() as Promise<T>;
}

export function fetchMyAchievements(): Promise<MyAchievementsResponse> {
  return achievementFetch('/api/v1/me/achievements');
}

export function fetchPublicAchievements(userId: string): Promise<PublicAchievementsResponse> {
  return achievementFetch(`/api/v1/users/${encodeURIComponent(userId)}/achievements`);
}
